import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'
  import { stylesList, defaultMapStyle } from '@/components/map/MapStyles'
  import store from '@/store'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FleetColor',
  props: {
    fleet: null,
    uiid: null
  },
  setup(__props: any) {

const props = __props as {    
    fleet: AloDbFleet,
    uiid: string
  };

  
  

  const fleetState = computed(()=> store.myGetters.fleetUiStateByUiid(props.uiid))  
         
  const color = computed(() => {
    const nameColor = (fleetState.value && fleetState.value.mapStyles && fleetState.value.mapStyles.name)
      ? fleetState.value.mapStyles.name 
      : defaultMapStyle.name
    return nameColor === 'Default' ? '#000000' : stylesList.find((c: any) => c.name === nameColor)?.color || '#000000'        
  })

  const backgroundColor = computed(() => {
    return color.value === '#ffffff' ? '#000000' : '#ffffff'
  })


return { __sfc: true,props, fleetState, color, backgroundColor, stylesList, store }
}

})